import { Link } from "@tanstack/react-router";
import { ArrowRight, LayoutPanelLeft, Waypoints } from "lucide-react";
import { Logo } from "@/components/logo";
import { ThemeToggle } from "@/components/theme-toggle";
import { useOturum } from "@/lib/oturum";
import { cevir } from "@/lib/dil";

export function KonseptSecici() {
  const { ben, cikis } = useOturum();
  return (
    <div className="min-h-dvh bg-bg font-manrope">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-5 py-6">
        <Logo height={28} />
        <div className="flex items-center gap-3">
          {ben && <span className="text-base text-ink-2">{ben.ad} · {cevir(ben.rolEtiket)}</span>}
          {ben && <button onClick={() => void cikis()} className="rounded-md border border-line px-3 py-1.5 text-base text-ink-2 hover:bg-surface-2">{cevir("Exit")}</button>}
          <ThemeToggle />
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-5 pb-16">
        <p className="text-sm font-semibold uppercase tracking-[0.12em] text-orange">{cevir("Home page concepts")}</p>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">{cevir("Two approaches, same data.")}</h1>
        <p className="mt-3 max-w-2xl text-md leading-relaxed text-ink-2">
          {cevir("Both concepts take Command centre (E-01) as home page; their difference is navigation logic and visual language. Light mode is default, can switch to dark mode from top right. Try on desktop, tablet and phone.")}
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <Link to="/konsept/a" className="group rounded-xl border border-line bg-surface p-6 shadow-[var(--shadow)] transition hover:-translate-y-0.5 hover:shadow-[var(--shadow-lg)]">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-navy text-white dark:text-[#0a141c]"><LayoutPanelLeft size={20} /></span>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wider text-ink-3">{cevir("Concept A")}</div>
                <div className="text-lg font-bold">{cevir("Command Center")}</div>
              </div>
            </div>
            <p className="mt-4 text-base leading-relaxed text-ink-2">
              {cevir("Control room language. Collapsible sidebar based on phases, ⌘K command palette, dense KPI ribbon, station × batch heat map, persistent details panel opening from right of riser list. Bottom tab bar on phone.")}
            </p>
            <ul className="mt-4 space-y-1 text-base text-ink-2">
              <li>{cevir("· IBM Plex Sans, tight grid, grey-navy surfaces")}</li>
              <li>{cevir("· Operator and quality team's \"let everything be visible\" expectation")}</li>
              <li>{cevir("· Meets spec's primary-detail and keyboard navigation requirement exactly")}</li>
            </ul>
            <span className="mt-5 inline-flex items-center gap-1 text-base font-semibold text-orange">{cevir("Open")} <ArrowRight size={14} className="transition group-hover:translate-x-0.5" /></span>
          </Link>

          <Link to="/konsept/b" className="group rounded-xl border border-line bg-surface p-6 shadow-[var(--shadow)] transition hover:-translate-y-0.5 hover:shadow-[var(--shadow-lg)]">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange text-white"><Waypoints size={20} /></span>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wider text-ink-3">{cevir("Concept B")}</div>
                <div className="text-lg font-bold">{cevir("Flow")}</div>
              </div>
            </div>
            <p className="mt-4 text-base leading-relaxed text-ink-2">
              {cevir("Process oriented. No sidebar; S1→SERT process track on top is main navigation, each station opens its own queue. Home page \"today\" view: three big numbers, component flow river, blocked/hold/SLA/my work ribbons.")}
            </p>
            <ul className="mt-4 space-y-1 text-base text-ink-2">
              <li>{cevir("· Manrope, wide spacing, soft surfaces, orange accent")}</li>
              <li>{cevir("· Field and PM's \"what is my next task\" priority")}</li>
              <li>{cevir("· On phone, track scrolls horizontally, ribbons stack vertically")}</li>
            </ul>
            <span className="mt-5 inline-flex items-center gap-1 text-base font-semibold text-orange">{cevir("Open")} <ArrowRight size={14} className="transition group-hover:translate-x-0.5" /></span>
          </Link>
        </div>

        <p className="mt-10 text-sm text-ink-3">{cevir("Data is mock. Derived from prototype seed (SURVREP 453228, Work front, disposition xlsx) and E-01 spec.")}</p>
      </main>
    </div>
  );
}
